// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import {
  MDBBtn, MDBCol, MDBContainer, MDBIcon, MDBModal, MDBModalBody, MDBRow,
} from 'mdbreact';
import connect from 'react-redux/es/connect/connect';

import SelectContractor from '../layout/SelectContractor';
import Notification from '../notification';

import { sendInviteFromWorkOrderToContractor } from '../../storage/actions/workOrdersActions';
import { toggleModal } from '../../storage/actions/modalsActions';
import prepareFilters from '../../utils/prepareFilters';
import { getStatus } from '../../utils/api/get/getWorkOrders';

const BulkWorkOrderRouteContractorModal = ({
  modalState,
  selectedWorkOrders,
  toggleModal,
  sendInviteFromWorkOrderToContractor,
  search,
  filters,
  activeTab,
}) => {
  const [selectedContractor, setSelectedContractor] = useState();
  const [requestData, setRequestData] = useState({});

  useEffect(() => {
    const newRequestData = modalState?.type?.mode === 'useFilters'
      ? {
        ...search,
        filters: prepareFilters(filters),
      }
      : { workOrdersId: selectedWorkOrders };
    setRequestData({ ...newRequestData, ...getStatus(activeTab) });
  }, [modalState?.type?.mode]);

  const closeModal = () => {
    toggleModal(false, 'bulkWorkOrderRouteContractorModal');
  };

  const handlerSubmit = (event) => {
    event.preventDefault();
    if (!selectedContractor?.value?.userId) {
      Notification('warning', { message: 'Please select contractor!' });
    } else {
      sendInviteFromWorkOrderToContractor({
        ...requestData,
        contractorId: selectedContractor.value.userId,
      });
    }
  };

  return (
    <MDBModal
      isOpen={modalState.isOpen}
      toggle={closeModal}
      centered
      className="modal-width-to-max-content"
      contentClassName="modal-container-width-to-max-content"
    >
      <MDBRow className="no-margins" style={{ justifyContent: 'flex-end', paddingRight: '10px' }}>
        <MDBIcon
          far
          icon="times-circle"
          onClick={closeModal}
          size="lg"
          className="blue-grey-text"
        />
      </MDBRow>
      <MDBModalBody style={{ fontFamily: 'Arial, Helvetica, sans-serif' }}>
        <MDBContainer>
          <MDBRow style={{ justifyContent: 'center' }}>
            <p
              style={{ color: 'black' }}
            >
              Route Contractor
            </p>
          </MDBRow>
          <MDBRow className="h-paddings-half">
            <MDBCol>
              <SelectContractor
                loaderColor="black"
                selectedContractor={selectedContractor}
                getSelectedContractor={setSelectedContractor}
                placeholder="Enter 3 or more letters to search contractors!"
              />
            </MDBCol>
          </MDBRow>
          <MDBRow style={{ justifyContent: 'center' }}>
            <MDBBtn
              color="info"
              className="signbutton"
              onClick={handlerSubmit}
            >
              Route
            </MDBBtn>
          </MDBRow>
        </MDBContainer>
      </MDBModalBody>
    </MDBModal>
  );
};

const mapDispatchToProps = {
  toggleModal,
  sendInviteFromWorkOrderToContractor,
};

const mapStateToProps = (state) => ({
  modalState: state.modalState.bulkWorkOrderRouteContractorModal,
  filters: state.workOrder?.filters,
  search: state.workOrder?.searchData,
  activeTab: state.applicationState.activeTab,
  selectedWorkOrders: state.applicationState.selectedWorkOrders,
});

export default connect(mapStateToProps, mapDispatchToProps)(BulkWorkOrderRouteContractorModal);
